<div ngbDropdown [class]="class" #dropdownInstance="ngbDropdown">
  <button
    ngbDropdownToggle
    #button
    aria-haspopup="true"
    [class]="buttonClass"
    [attr.id]="button_id"
    [attr.aria-controls]="menu_id"
    [attr.aria-label]="ariaLabel"
    [disabled]="menuDisabled()"
  >
    <ng-container *ngTemplateOutlet="menuButtonTemplateRef; context: { label }" />
    <ng-container *ngIf="!menuButtonTemplateRef">{{ label }}</ng-container>
  </button>
  <div
    #menu
    ngbDropdownMenu
    [attr.id]="menu_id"
    role="menu"
    [attr.aria-labelledby]="button_id"
    [class]="menuClass ?? ''"
  >
    <ng-container *ngFor="let link of links; let i = index">
      <a
        ngbDropdownItem
        role="menuitem"
        [disabled]="link.disabled ?? false"
        [routerLink]="link.href"
        [class]="menuItemClass ?? ''"
      >
        <ng-container
          [ngTemplateOutlet]="menuItemTemplateRef ?? itemLabel"
          [ngTemplateOutletContext]="{ $implicit: link, index: i }"
        />
      </a>
    </ng-container>
    <ng-container *ngFor="let action of actions; let i = index">
      <div
        ngbDropdownItem
        role="menuitem"
        [disabled]="action.disabled ?? false"
        [class]="menuItemClass ?? ''"
        (click)="action.callback(action)"
      >
        <ng-container
          [ngTemplateOutlet]="menuItemTemplateRef ?? itemLabel"
          [ngTemplateOutletContext]="{ $implicit: action, index: i }"
        />
      </div>
    </ng-container>
  </div>
</div>

<ng-template #itemLabel let-item>
  {{ item.label }}
</ng-template>
